// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\r\n/* Tus estilos existentes con scope */\n.textCamp[data-v-6b409bd7]{\r\n    max-height: 100%;\r\n    resize: none;\n}\r\n", ""]);
// Exports
module.exports = exports;
